import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/layout";
import Home from "./pages/home";
import "./styles/main.scss";
import { Term } from "./pages/legal/Term";
import { Cookie } from "./pages/legal/Cookie";
import { Privacy } from "./pages/legal/Privacy";
import Brand from "./pages/brand/Brand";
import VerifyInfo from "./pages/verify";
import Web3Ignite from "./pages/web3Ignite";
import ScrollToTop from "./components/ScrollTop";

const App: React.FC = () => {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="term" element={<Term />} />
          <Route path="cookie" element={<Cookie />} />
          <Route path="privacy" element={<Privacy />} />
          <Route path="brand" element={<Brand />} />
          <Route path="verify" element={<VerifyInfo />} />
          <Route path="token" element={<Brand />} />
          <Route path="web3-ignite" element={<Web3Ignite />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default App;
